<app-form-page [content]="content" [input]="input" [action]="action" />

<ng-template #content>
  <div class="m-t-2 m-b-3 text-align-center">
    <svg-icon
      role="img"
      src="assets/images/aptem-assess-logo-content.svg"
      data-ua-id="landing-page-logo"
    >
    </svg-icon>
  </div>

  <h2 class="text-bold text-align-center m-b-3">
    <span>Final step to register for Aptem Assess </span>
  </h2>

  <div class="content-layout-column m-t-3 m-b-3">
    <div>
      <p>
        Thank you for validating your email address. We need a few additional
        details from you to set up your organisation.
      </p>

      <p>
        If you would like other people in your organisation to also have access
        to your Aptem Assess account, you can optionally provide their email
        address(es) below.
      </p>
    </div>
  </div>
</ng-template>

<form [formGroup]="landingForm" (ngSubmit)="onSubmit()">
  <ng-template #input>
    <div class="text-text-main">
      <app-text-input
        trackingId="full-name-input-landing"
        [config]="{
          label: 'Full name',
          controlName: 'fullName',
          elementId: '1',
        }"
      >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="email-input-landing"
        [config]="{
          label: 'Business email',
          controlName: 'emailAddress',
          elementId: '2'
        }"
        (changed)="updateOrgCodeFromEmail()"
      >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="org-name-input-landing"
        [config]="{
          label: 'Full organisation name',
          subText: 'e.g. Acme Industries',
          controlName: 'orgName',
          elementId: '3'
        }"
      >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <div>
        <div class="m-b-1">
          <label [for]="4" class="m-l-1 m-b-1 text-sm font-weight-medium">
            Organisation code
          </label>
          <label class="text-sm font-weight-medium required-indicator">*</label>
        </div>

        <div class="input-wrapper">
          <input
            class="user-input user-input-primary user-input-lg"
            type="search"
            placeholder="e.g. {{ orgCode }}"
            [formControl]="orgCodeControl"
          />
        </div>
        <div class="validation-wrapper">
          @if (orgCodeControl.touched && orgCodeControl.invalid) {
          <div class="invalid-indicator">
            <label class="m-l-1 text-xs font-weight-medium invalid-text"
              >Please enter a valid organisation code.</label
            >
          </div>
          }
          <div class="m-t-1 m-b-4 subtext">
            What your organisation will be known by. It needs to be short, with
            no spaces, punctuation or uppercase characters. For example, an
            organisation with their email domain as 'acme-inc' could use this as
            their organisation code. This will be used in assessment links for
            learners taking the assessment. e.g.
            https://app.aptemassess.co.uk/{{
              !orgCodeControl.invalid ? orgCodeControl.value : orgCode
            }}/example1'
          </div>
        </div>
      </div>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="admin1-email-input-landing"
        [config]="{
          label: 'Admin email 1',
          controlName: 'adminEmail1',
          elementId: '5',
          isRequired: false,
          validationMessage: 'Please enter a valid email address'
        }"
      >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="admin2-email-input-landing"
        [config]="{
          label: 'Admin email 2',
          controlName: 'adminEmail2',
          elementId: '6',
          isRequired: false,
          validationMessage: 'Please enter a valid email address'
        }"
      >
      </app-text-input>
    </div>
    <div class="text-text-main">
      <app-text-input
        trackingId="admin3-email-input-landing"
        [config]="{
          label: 'Admin email 3',
          controlName: 'adminEmail3',
          elementId: '7',
          isRequired: false,
          validationMessage: 'Please enter a valid email address'
        }"
      >
      </app-text-input>
    </div>
  </ng-template>

  <ng-template #action>
    <div class="action-button-block-sm-center-md m-b-4">
      <app-button
        [config]="{ type: 'submit', disabled: landingForm.invalid }"
        trackingId="signup-landing"
        (clicked)="onSubmit()"
      >
        Send invite
      </app-button>
    </div>
  </ng-template>
</form>
